import { createFileRoute } from "@tanstack/react-router";
import { CampaignHub } from "@/components/campaigns/CampaignHub";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/campaigns/")({
	component: CampaignsHubPage,
});

function CampaignsHubPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	if (!campaignId) {
		return (
			<div className="mx-auto max-w-5xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		);
	}
	return (
		<CampaignHub
			campaignId={campaignId}
			accountName={session.campaign?.name ?? undefined}
		/>
	);
}
